<template>
  <SfSidebar
    :visible="isVisible"
    class="sf-sidebar--right sf-sidebar--icon sf-sidebar__underlay-help"
    @close="closeModal"
  >
    <div class="underlay-help-content">
      <SfHeading
        class="sf-heading--left"
        :title="heading"
        :level="2"
      />

      <div
        v-if="content"
        class="underlay-help-content__body"
        v-html="content"
      />

      <p
        v-else-if="!isLoading"
        class="underlay-help-content__empty"
      >
        Der Hilfetext ist noch nicht hinterlegt. Bitte den Magento-CMS-Block
        <code>{{ blockIdentifier }}</code>
        anlegen und befüllen.
      </p>

      <p
        v-else
        class="underlay-help-content__empty"
      >
        Hilfe wird geladen…
      </p>
    </div>
  </SfSidebar>
</template>

<script>
import { mapGetters } from 'vuex'
import { SfSidebar, SfHeading } from '@storefront-ui/vue'
import guidedCheckoutConfig from 'theme/config/guided-checkout'

export default {
  name: 'MModalUnderlayHelp',
  components: {
    SfSidebar,
    SfHeading
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getCmsBlockByIdentifier: 'cmsBlock/getCmsBlockByIdentifier'
    }),
    blockIdentifier () {
      return (
        guidedCheckoutConfig.underlayHelpCmsBlock ||
        'guided-checkout-underlay-help'
      )
    },
    cmsBlock () {
      return this.getCmsBlockByIdentifier(this.blockIdentifier) || null
    },
    heading () {
      return (this.cmsBlock && this.cmsBlock.title) || 'Hilfe bei der Dämmungsauswahl'
    },
    content () {
      return (this.cmsBlock && this.cmsBlock.content) || ''
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (visible) {
        if (visible) {
          this.loadCmsBlock()
        }
      }
    }
  },
  methods: {
    async loadCmsBlock () {
      if (this.cmsBlock && this.cmsBlock.content) return

      this.isLoading = true
      try {
        await this.$store.dispatch('cmsBlock/single', {
          key: 'identifier',
          value: this.blockIdentifier
        })
      } finally {
        this.isLoading = false
      }
    },
    closeModal () {
      this.$emit('close', this.modalData.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.underlay-help-content {
  &__body {
    margin-top: 0.75rem;
    line-height: 1.5;

    ::v-deep {
      p {
        margin: 0 0 0.75rem;
      }

      ul,
      ol {
        margin: 0 0 0.75rem;
        padding-left: 1.25rem;
      }

      h2,
      h3,
      h4 {
        margin: 1rem 0 0.5rem;
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  &__empty {
    margin: 1rem 0 0;
    color: var(--c-dark-variant);
    font-size: 0.9375rem;
    line-height: 1.4;

    code {
      font-size: 0.875rem;
    }
  }
}
</style>
